import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { LocationSelect } from "@/components/LocationSelect";

export const AddBottlesDialog = ({ open, onOpenChange, wineId, onSaved }) => {
  const [count, setCount] = useState(1);
  const [box, setBox] = useState("");
  const [loc, setLoc] = useState("");
  const [buy, setBuy] = useState({ supplier: "", purchase_date: "", purchase_price: "" });
  const setB = (k) => (e) => setBuy({ ...buy, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/wines/${wineId}/bottles`, { count: Number(count), box_number: box, location_id: loc || null, supplier: buy.supplier || null, purchase_date: buy.purchase_date || null, purchase_price: buy.purchase_price === "" ? null : Number(buy.purchase_price) });
      toast.success("Bottles added");
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#161214] border-[#2E252A]" data-testid="add-bottles-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl">Add bottles</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <Input type="number" min="1" max="500" value={count} onChange={(e) => setCount(e.target.value)} placeholder="Number of bottles" data-testid="add-bottles-count-input" />
          <Input value={box} onChange={(e) => setBox(e.target.value)} placeholder="Box number (optional)" data-testid="add-bottles-box-input" />
          <LocationSelect value={loc} onChange={setLoc} testId="add-bottles-location-select" allowCreate allowPending />
          <p className="text-xs text-[#6E665D]">If the box already exists, bottles take the box's location.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] pt-2">This purchase (optional)</p>
          <Input value={buy.supplier} onChange={setB("supplier")} placeholder="Supplier" data-testid="add-bottles-supplier-input" />
          <div className="grid grid-cols-2 gap-3">
            <Input type="date" value={buy.purchase_date} onChange={setB("purchase_date")} data-testid="add-bottles-date-input" />
            <Input type="number" step="0.01" min="0" value={buy.purchase_price} onChange={setB("purchase_price")} placeholder="Price per bottle" data-testid="add-bottles-price-input" />
          </div>
          <p className="text-xs text-[#6E665D]">Left empty, the wine's first purchase details are used. Condition and document can be set per bottle afterwards.</p>
          <Button type="submit" className="w-full bg-[#5C1D24] hover:bg-[#8C2B36] text-[#F5F0EB]" data-testid="add-bottles-save-button">Add</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
